import { PAGE_VIEW_EVENT } from "@zapier/canvas-constants";
import { useCurrentAccountId } from "@zapier/identity";
import { useEffect } from "react";

export function useEmitPageViewEvent() {
  const currentAccountId = useCurrentAccountId();
  useEffect(() => {
    if (window.EventToolkit?.emit) {
      window.EventToolkit.emit(
        {
          system_name: "canvas",
          account_id: currentAccountId,
        },
        PAGE_VIEW_EVENT,
      );
    }
  }, [currentAccountId]);
}
